import React from 'react';
import { Stack } from '@mui/material';

import { IProject } from '@types';
import { GroupFold } from '@hooks';
import { CardGroup } from 'components/common/CardGroup/CardGroup';
import { TeamsTableHeader } from '../constants/headers';
import { compareMembers } from '../utils/sorting';
import { MemberCard } from './MemberCard';

type Props = {
  projects: IProject[];
  visibleHeaders: TeamsTableHeader[];
  fold: GroupFold;
};

export const TeamsCardList: React.FC<Props> = ({
  projects,
  visibleHeaders,
  fold,
}) => (
  <Stack gap={1} pb={2}>
    {projects.map(({ id, name, members }) => (
      <CardGroup key={id} name={name} count={members.length} {...fold(id)}>
        {[...members]
          .sort((a, b) =>
            compareMembers(a, b, TeamsTableHeader.ProjectTeamMember, 'asc'),
          )
          .map((member) => (
            <MemberCard
              key={member.id}
              member={member}
              projectId={id}
              visibleHeaders={visibleHeaders}
            />
          ))}
      </CardGroup>
    ))}
  </Stack>
);
